<!-- prevent focus change on mousedown: Firefox moves focus to the surrounding link, which closes the menu before the click -->
<div class="item-actions" (mousedown)="$event.preventDefault()" [ngClass]="['item-actions--position-' + menuPositionY, 'item-actions--position-' + menuPositionX, isVisible ? 'item-actions--visible' : '']">
  <div class="item-actions__menu"
       [ngClass]=""
       #menuEl>
    <button role="button" class="item-actions__item"
            [ngClass]="{'disabled': !item.isActive}" *ngFor="let item of menuItems"
            (click)="onItemClicked($event); item.func()" [tabIndex]="item.isActive ? 0 : -1">
      <span class="icon" *ngIf="item.icon.length"><brt-icon [icon]="item.icon"></brt-icon></span>
      <span>{{item.title}}</span>
    </button>
  </div>
</div>
